import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import { AnalyticsEvent } from '~/modules/services/analyticsService';
import { AuthenticationEvent, GtmEventType } from './gtmEventType';

export type LoginAnalyticsEvent = {
    authenticationMethod: string;
    userId: string;
    company: string;
    relationship: string;
    role: string;
    timestamp: number;
    authenticationOrigin: string;
    eventType: string;
} & AnalyticsEvent;

export class GtmLoginType extends GtmEventType {
    // @ts-expect-error * Automated Type Error Fix
    canHandle(event): boolean {
        return event.topic === AnalyticsEventTopic.ANALYTICS_AUTHENTICATION && event.eventType === 'login';
    }

    // TODO: implementations for authentication_type and logins.
    getBody(event: LoginAnalyticsEvent): AuthenticationEvent {
        return {
            event: 'custEv_login',
            authentication_method: event.authenticationMethod,
            authentication_type: 'tbid',
        };
    }
}
